import Axios from "axios";

export const httpInterceptor = {
  setupInterceptors: (store) => {
    Axios.interceptors.request.use(
      function (config) {
        const token = localStorage.getItem("accessToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    Axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("accessToken");
          window.location.href = "/login";
        }

        return Promise.reject(error);
      }
    );
  },
};
